module.exports = __webpack_public_path__ + "media/assets/images/blog/polly_block_2-small-7c3cf789b987004d5068a8686764a69b.png";